var uploadIcon = "/home/circleci/app/src/assets/img/uploadIcon.svg";

export { uploadIcon as default };
